var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== 'function' && b !== null) throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
var HoverInfo = /** @class */function (_super) {
  __extends(HoverInfo, _super);
  function HoverInfo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HoverInfo.prototype.render = function () {
    var _this = this;
    var _a, _b;
    var hoverInfoStyle = {
      left: this.props.position.x - 50,
      top: this.props.position.y - ((_b = (_a = this.refHoverInfo) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0) - 20,
      display: this.props.active ? 'block' : 'none'
    };
    var HoverComponent = this.props.hoverComponent;
    return React.createElement('div', {
      ref: function ref(_ref) {
        return _this.refHoverInfo = _ref;
      },
      className: 'HoverInfo',
      style: hoverInfoStyle
    }, this.props.hoverComponent ? React.createElement(HoverComponent, {
      value: __assign(__assign({}, this.props.value), {
        name: this.props.name
      })
    }) : React.createElement(React.Fragment, null, React.createElement('p', null, this.props.name), isFinite(this.props.value) && React.createElement('p', null, this.props.valueTitle ? this.props.valueTitle + ': ' : '', this.props.value)), React.createElement('style', null, '\n          .HoverInfo {\n            position: fixed;\n            min-width: 8ch;\n            background-color: white;\n            box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.3);\n            padding: 7px;\n            border-radius: 4px;\n          }\n          .HoverInfo p {\n            margin: 0;\n            font-size: 0.9em;\n          }\n        '));
  };
  return HoverInfo;
}(React.Component);
export default HoverInfo;